import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { EmptyState } from '@/shared/components/EmptyState'
import { SystemStateIllustration } from '@/shared/components/illustrations/SystemStateIllustration'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'

export function NotFoundPage() {
  const { t } = useTranslation()
  useDocumentTitle(t('ui.not_found.page_title'))

  return (
    <EmptyState title={t('ui.not_found.title')} description={t('ui.not_found.description')}>
      <SystemStateIllustration variant="not_found" className="mt-2 mb-4" />
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Button asChild variant="default" size="sm">
          <Link to="/">{t('ui.not_found.home')}</Link>
        </Button>
        <Button asChild variant="outline" size="sm">
          <Link to="/faq">{t('ui.not_found.support')}</Link>
        </Button>
      </div>
    </EmptyState>
  )
}
